module.exports = __webpack_public_path__ + "img/team_danny.cb67c58b.jpg";